import { EnvironmentVariables } from "models/environment";
import env from "modules/env/env";
import React from "react";
import { Navigate } from "react-router-dom";
interface ICountryRoute {
  countryCode: string[];
  children: React.ReactNode;
}
const CountryRoute: React.FC<ICountryRoute> = (props: ICountryRoute) => {
  const { countryCode, children } = props;
  const envLanguage = EnvironmentVariables.countryCode;
  const language: string | undefined = env(envLanguage);
  if (countryCode?.includes(language as string)) {
    return children;
  } else {
    return <Navigate to="/" replace/>
  }
};

export default CountryRoute;
